/**
 * Store minimal temporaire pour useAuthStore
 * TODO: Réimplémenter complètement avec authService
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@sphere/auth/domain';

// Types temporaires
type LoginRequest = { email: string; password: string };
type RegisterUserRequest = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
};

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;

  login: (credentials: LoginRequest) => Promise<void>;
  register: (userData: RegisterUserRequest) => Promise<void>;
  logout: () => void;
  setUser: (user: User) => void;
  clearError: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      login: async (credentials: LoginRequest) => {
        set({ isLoading: true, error: null });
        try {
          // TODO: Implémenter avec authService
          console.warn('useAuthStore: login not implemented');
          set({ isLoading: false });
        } catch (error) {
          set({ isLoading: false, error: 'Login failed' });
        }
      },

      register: async (userData: RegisterUserRequest) => {
        set({ isLoading: true, error: null });
        try {
          // TODO: Implémenter avec authService
          console.warn('useAuthStore: register not implemented');
          set({ isLoading: false });
        } catch (error) {
          set({ isLoading: false, error: 'Registration failed' });
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null,
        });
      },

      setUser: (user: User) => {
        set({
          user,
          isAuthenticated: true,
        });
      },

      clearError: () => {
        set({ error: null });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
